module.exports = __webpack_public_path__ + "static/media/8.0f39828e.jpg";